module.exports = __webpack_public_path__ + "img/anli2.4fa3a944.jpg";